// Auto-update the installed PWA / open tabs whenever the backend reports a
// new APP_VERSION (i.e. after a fresh deploy). No hard reinstall needed.
import { toast } from "sonner";

const API = process.env.REACT_APP_BACKEND_URL + "/api";
const CHECK_MS = 60_000;

let currentVersion = null;
let checking = false;
let reloading = false;

async function fetchVersion() {
  try {
    const res = await fetch(`${API}/version`, { cache: "no-store", credentials: "omit" });
    if (!res.ok) return null;
    const data = await res.json();
    return data && data.version ? String(data.version) : null;
  } catch {
    return null;
  }
}

async function performReload(newVersion) {
  if (reloading) return;
  reloading = true;
  // Refresh the service worker so it can pick up any new push handlers etc.
  if ("serviceWorker" in navigator) {
    try {
      const reg = await navigator.serviceWorker.getRegistration();
      if (reg) await reg.update();
    } catch (_) { /* no-op */ }
  }
  toast.success("New version available — refreshing…", { duration: 2000 });
  setTimeout(() => {
    const url = new URL(window.location.href);
    url.searchParams.set("v", newVersion);
    window.location.replace(url.toString());
  }, 1200);
}

async function check() {
  if (checking || reloading) return;
  checking = true;
  try {
    const v = await fetchVersion();
    if (!v) return;
    if (currentVersion == null) {
      currentVersion = v;
      return;
    }
    if (v !== currentVersion) {
      await performReload(v);
    }
  } finally {
    checking = false;
  }
}

export function startUpdateWatcher() {
  if (window.__ccUpdateWatcherStarted) return;
  window.__ccUpdateWatcherStarted = true;
  check();
  setInterval(check, CHECK_MS);
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") check();
  });
  window.addEventListener("focus", check);

  // If a new Service Worker takes control (e.g. sw.js content changed),
  // reload once so the page is served by the fresh worker.
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (reloading) return;
      reloading = true;
      window.location.reload();
    });
  }
}
